// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"dd31006766--checkbox--Y2Njc","box":"dd31006766--box--FHmxp","invalid":"dd31006766--invalid--uf33E","disabled":"dd31006766--disabled--djeBi"};